import React from 'react';
import Tooltip from '@omilia/tooltip';

const Warning = () => (
  <div data-test="warning">
    <Tooltip
      content={
        <React.Fragment>
          Complete configuration
          <br />
          to use this rule!
        </React.Fragment>
      }
    >
      <i className="icon-warning rule" />
    </Tooltip>
  </div>
);

export default Warning;
